const BOT_USER_AGENTS = [/Tenable WAS/];

export const isBot = () => {
    return BOT_USER_AGENTS.some((botUserAgentRegex) =>
        botUserAgentRegex.test(navigator.userAgent)
    );
};
